export enum WaitTimeOption {
    DoNotShow = "donotshow",
    ByNumHours = "hours",
    ByNumVisitors = "visitors",
    FullDay = "fullday"
}